import { usePageTitle } from '@/hooks/use-page-title';
import { HeroSection } from '@/sections/hero-section';
import { FeaturesSection } from '@/sections/features-section';
import { HowItWorksSection } from '@/sections/how-it-works-section';
import { ComplianceSection } from '@/sections/compliance-section';
import { CtaSection } from '@/sections/cta-section';

export function HomePage() {
  usePageTitle('Vocalización web accesible');

  return (
    <>
      <HeroSection />
      <FeaturesSection />
      <HowItWorksSection />
      <ComplianceSection />
      <CtaSection />
    </>
  );
}
